<template>
  <v-card class="pa-4">
    <v-card-text>
            <v-row>

              
              <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn  color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSV">
                  {{$t('comun.boton_importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleCSVUpload"
                  />
                </v-btn>
              </v-col>
            </v-row>
        </v-card-text>
    <div class="text-h6 mb-4 text-center">
      {{ $t('simulacion.modulo.ppa_venta.titulo') }}
    </div>
    <!-- NUEVO SWITCH -->
    <v-row class="mb-4">
      <v-col cols="12" md="6">
        <v-switch
          :model-value="modoMinPool"
          @update:modelValue="actualizarModoMinPool"
          inset
          color="primary"
          hide-details
          :label="labelModoPpaVenta"
        />
      </v-col>
    </v-row>

    
    <v-table class="elevation-2">
      <thead>
        <tr>
          <th class="text-center text-h6">
            {{ $t('simulacion.modulo.ppa_venta.anio') }}
          </th>
          <th
            v-if="ejecucion.OPC_PCPPAPV == 1"
            class="text-center text-h6"
          >
            {{ $t('simulacion.modulo.ppa_venta.pcppapv') }}
          </th>
          <th
            v-if="ejecucion.OPC_PCPPAEOL == 1"
            class="text-center text-h6"
          >
            {{ $t('simulacion.modulo.ppa_venta.pcppaeol') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in tablaLocal" :key="item.anio">
          <td class="text-center align-middle">
            <v-text-field
              :model-value="item.anio"
              readonly
              density="compact"
              variant="plain"
              hide-details
              class="pa-0 ma-0 text-center"
              style="text-align: center;"
              input-class="text-center"
            />
          </td>
          <td
            v-if="ejecucion.OPC_PCPPAPV == 1"
            class="text-center align-middle"
          >
            <v-text-field
              :model-value="formatNumber(item.pcppapv)"
  @update:modelValue="val => updateCampo(item, 'pcppapv', val)"
              density="compact"
              variant="outlined"
              hide-details
              class="pa-0 ma-0 text-center"
              input-class="text-center"
            />
          </td>
          <td
            v-if="ejecucion.OPC_PCPPAEOL == 1"
            class="text-center align-middle"
          >
            <v-text-field
              :model-value="formatNumber(item.pcppaeol)"
  @update:modelValue="val => updateCampo(item, 'pcppaeol', val)"
              density="compact"
              variant="outlined"
              hide-details
              class="pa-0 ma-0 text-center"
              input-class="text-center"
            />
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-card>
</template>




<script>
import Swal from 'sweetalert2';
export default {
  name: 'ComponentePPAventa',
  props: {
    anio_cod: Number,
  anio_fin: Number,
  modelValue: Array,
  ejecucion: {
      type: Object,
      required: true,
    },
    datos_generales:{
        type:Object,
        required:true,
    },
},
emits: ['update:modelValue', 'update:modoPpaVenta'],
  data() {
    return {
      local_eolica: { ...this.eolica}, 
      local_fotovoltaica: { ...this.fotovoltaica},
      tablaLocal: [],
      anio_min: 2025,
      anio_max:2100,
      columnasEsperadas: {
        anio: ['Año'],
        pcppapv: ['Precio fijo venta solar'],
        pcppaeol: ['Precio fijo venta eólica']
      }

            
    
    }
  },
  watch: {
  datos_generales: {
    handler() {
      console.log("Watcher datos_generales:", this.datos_generales.anio_inicio, this.datos_generales.anio_fin)
      this.first_index = this.datos_generales.anio_inicio - this.anio_min
      this.last_index = this.datos_generales.anio_fin - this.anio_min + 1
      this.tablaLocal = this.modelValue
        .filter(item =>
    item.anio >= this.datos_generales.anio_inicio &&
    item.anio <= this.datos_generales.anio_fin
  )
  .map(item => ({ ...item }));
    },
    immediate: true,
    deep: true,
  },
   modelValue: {
    handler(val) {
      console.log('[WATCH modelValue] nuevo valor recibido:', JSON.stringify(val, null, 2));
      const nueva = val.map(item => ({ ...item }));
      const actual = this.tablaLocal.map(item => ({ ...item }));
      if (JSON.stringify(nueva) !== JSON.stringify(actual)) {
        
        this.tablaLocal = nueva;
      }
    },
    deep: true,
    immediate: true
  }
},

  methods: {
     actualizarModoMinPool(valor) {
    this.$emit('update:modoPpaVenta', valor ? 1 : 0)
  },
   emitirCambios() {
  const tablaNumerica = this.tablaLocal.map(item => {
    const nuevo = { ...item };
    if (this.ejecucion.OPC_PCPPAPV == 1 && typeof nuevo.pcppapv === 'string') {
      nuevo.pcppapv = parseFloat(nuevo.pcppapv.replace(',', '.'));
    }
    if (this.ejecucion.OPC_PCPPAEOL == 1 && typeof nuevo.pcppaeol === 'string') {
      nuevo.pcppaeol = parseFloat(nuevo.pcppaeol.replace(',', '.'));
    }
    return nuevo;
  });

  this.$emit('update:modelValue', tablaNumerica);
},
   generarTabla() {
      if (this.modelValue && this.modelValue.length > 0) {
        
        return;
      }

      
      const nueva = [];
      for (let anio = this.anio_min; anio <= 2100; anio++) {
        nueva.push({
          anio,
          pcppapv: 0,
          pcppaeol: 0
        });
      }

      
      this.$emit('update:modelValue', {
        fragmento: nueva,
        offset: 0
      });
    },
    formatNumber(value) {
    if (value === null || value === undefined || value === '') return '';
    const num = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
    if (isNaN(num)) return '';
    return num.toLocaleString('es-ES', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20
    });
  },

  updateCampo(item, campo, val) {
    const valorNum = parseFloat(val.replace(',', '.'));
    if (!isNaN(valorNum)) {
      item[campo] = valorNum;
      this.emitirCambios();
    }
  },

  exportToCSV() {
    const headers = ['Año'];
    if (this.ejecucion.OPC_PCPPAPV == 1) headers.push('Precio fijo venta solar');
    if (this.ejecucion.OPC_PCPPAEOL == 1) headers.push('Precio fijo venta eólica');

    const rows = this.tablaLocal.map(item => {
      const fila = [item.anio];
      if (this.ejecucion.OPC_PCPPAPV == 1) {
        fila.push((item.pcppapv ?? '').toString().replace('.', ','));
      }
      if (this.ejecucion.OPC_PCPPAEOL == 1) {
        fila.push((item.pcppaeol ?? '').toString().replace('.', ','));
      }
      return fila.join(';');
    });

    const contenido = [headers.join(';'), ...rows].join('\n');
    const blob = new Blob(['\uFEFF' + contenido], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    let nombre = this.$t('simulacion.modulo.ppa_venta.titulo').toLowerCase().replace(/ /g, '_');
    a.href = url;
    a.download = `${nombre}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  },

  revisarCabeceras(header) {
  const columnasValidas = ['anio'];
  if (this.ejecucion.OPC_PCPPAPV == 1) columnasValidas.push('pcppapv');
  if (this.ejecucion.OPC_PCPPAEOL == 1) columnasValidas.push('pcppaeol');

  const etiquetasEsperadas = columnasValidas.flatMap(key => this.columnasEsperadas[key] ?? []);

  const normalizar = str => str.toLowerCase().trim();

  const cabecerasFaltantes = etiquetasEsperadas.filter(
    etiqueta => !header.some(h => normalizar(h) === normalizar(etiqueta))
  );

  const cabecerasSobrantes = header.filter(
    h => !etiquetasEsperadas.some(etiqueta => normalizar(h) === normalizar(etiqueta))
  );

  if (cabecerasFaltantes.length > 0 || cabecerasSobrantes.length > 0) {
    let mensaje = '';

    if (cabecerasFaltantes.length > 0) {
      mensaje += `${this.$t('mensajes.error')}: <strong>${cabecerasFaltantes.join(', ')}</strong><br>`;
    }
    if (cabecerasSobrantes.length > 0) {
      mensaje += `${this.$t('mensajes.alerta_cabeceras')}: <strong>${cabecerasSobrantes.join(', ')}</strong>`;
    }

    Swal.fire({
      icon: 'error',
      title: this.$t('mensajes.error'),
      html: mensaje,
      confirmButtonText: 'OK'
    });

    return true;
  }

  return false;
},


  handleCSVUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const csvData = e.target.result;
    const [headerLine, ...lines] = csvData
      .split("\n")
      .map(line => line.trim())
      .filter(line => line.length > 0);

    const delim = this.guess_delimiter(headerLine);
    const headers = headerLine.split(delim);

    if (this.revisarCabeceras(headers)) return;

    const parsed = lines.map(line => {
      const values = line.split(delim);
      const obj = {};
      headers.forEach((header, i) => {
        const clave = this.devolverPropColumnas(header);
        const valorRaw = values[i]?.replace(',', '.');
        obj[clave] = valorRaw === '' || isNaN(valorRaw) ? values[i] : Number(valorRaw);
      });
      return obj;
    });

    // Filtro por anio y campos activos
    const actualizados = this.tablaLocal.map(orig => {
      const entrada = parsed.find(p => p.anio == orig.anio);
      if (!entrada) return orig;

      const actualizado = { ...orig };
      if (this.ejecucion.OPC_PCPPAPV == 1 && 'pcppapv' in entrada) actualizado.pcppapv = entrada.pcppapv;
      if (this.ejecucion.OPC_PCPPAEOL == 1 && 'pcppaeol' in entrada) actualizado.pcppaeol = entrada.pcppaeol;
      return actualizado;
    });

    this.tablaLocal = actualizados;
    this.emitirCambios();
  };
  reader.readAsText(file, 'UTF-8');
  event.target.value = ''; 
},

guess_delimiter(headerLine) {
  const delimiters = [';', ',', '\t'];
  let maxDelimiter = ';';
  let maxCount = 0;

  delimiters.forEach(d => {
    const count = headerLine.split(d).length;
    if (count > maxCount) {
      maxCount = count;
      maxDelimiter = d;
    }
  });

  return maxDelimiter;
},
devolverPropColumnas(etiqueta) {
  const normalizar = str => str.toLowerCase().trim();
  
  for (const [prop, etiquetas] of Object.entries(this.columnasEsperadas)) {
    if (etiquetas.some(e => normalizar(e) === normalizar(etiqueta))) {
      return prop;
    }
  }

  return null; // o etiqueta normalizada si prefieres fallback
},


importFromCSV() {
  this.$refs.fileInput.click();
},

  


  },
  
  
mounted() {
  this.generarTabla();

  if (this.modelValue && this.modelValue.length > 0) {
    this.tablaLocal = this.modelValue
      .filter(item =>
        item.anio >= this.datos_generales.anio_inicio &&
        item.anio <= this.datos_generales.anio_fin)
      .map(item => ({ ...item }));

    // Formatear valores numéricos con coma (es-ES)
    this.tablaLocal.forEach(item => {
      if (this.ejecucion.OPC_PCPPAPV == 1 && typeof item.pcppapv === 'number') {
        item.pcppapv = item.pcppapv.toLocaleString('es-ES', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 20
        });
      }
      if (this.ejecucion.OPC_PCPPAEOL == 1 && typeof item.pcppaeol === 'number') {
        item.pcppaeol = item.pcppaeol.toLocaleString('es-ES', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 20
        });
      }
    });
  }
},

  computed: {
  tabla: {
    get() {
      return this.modelValue
    },
    set(val) {
      this.$emit('update:modelValue', val)
    }
  },
  modoMinPool() {
    return Number(this.ejecucion?.OPC_PPA_VENTA_MIN_POOL ?? 0) === 1
  },
  labelModoPpaVenta() {
    return this.$t('simulacion.modulo.ppa_venta.modo_min_pool')
  
  }
}
}
</script>